const { company } = window.env;

export const isGoal = () => {
  return company.id === 'k-goal';
};
export const isGood = () => {
  return company.id === 'k-good';
};
